import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

export const Content = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1080px;
        flex-direction: row;
    }
`
export const SectionOurTeam = styled(motion(Box))`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 300px;
    height: 395px;
    border-radius: 30px;
    margin-bottom: 20px;
    background: ${({ theme }) => theme.colors.primary};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 82%;
        height: 295px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        margin-bottom: 0;
        width: 434px;
        height: 840px;
    }
`
export const SectionTeam = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 82%;
        flex-direction: row;
        flex-wrap: wrap;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        flex-direction: row;
        flex-wrap: wrap;
        height: 840px;
        width: 620px;
    }
`
export const TypographyContent = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 18px;
    text-align: start;
    margin-top: 30px;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 25px;
        margin-top: 10px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 28px;
        margin-top: 30px;
    }
`
export const ContentInformation = styled(Box)`
    display: flex;
    flex-direction: column;
    min-height: 310px;
    justify-content: space-between;
    align-items: start;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        min-height: 260px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        min-height: 370px;
    }
`
export const ImageCompany = styled.img`
    width: 64px;
    height: 64px;
    filter: brightness(0) invert(1);
    object-fit: cover;
`
export const ContentButton = styled(Link)`
    min-width: 178px;
    height: 38px;
    background: ${({ theme }) => theme.colors.second};
    color: ${({ theme }) => theme.colors.white};
    border: 2px solid ${({ theme }) => theme.colors.second};
    padding: 0 10px;
    position: relative;
    z-index: 1;
    cursor: pointer;
    text-align: center;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    margin-top: 10px;
    :hover {
        color: ${({ theme }) => theme.colors.dark};
        border: 2px solid ${({ theme }) => theme.colors.white};
    }
    :after {
        content: '';
        color: ${({ theme }) => theme.colors.dark};
        background: ${({ theme }) => theme.colors.white};
        border: 2px solid ${({ theme }) => theme.colors.white};
        position: absolute;
        z-index: -1;
        padding: 16px 20px;
        display: block;
        border-radius: 50%;
        left: -50%;
        right: -50%;
        top: -150%;
        bottom: -150%;
        transform: scale(0, 0);
        transition: all 0.4s ease;
    }
    :hover::after {
        transition: all 0.6s ease-out;
        transform: scale(1, 1);
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        min-width: 198px;
        height: 39px;
        margin-top: 10px;
    }
`
export const TypographyTitleSection = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 26px;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 23px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 41px;
    }
`
